import React, { useState } from 'react';
import { Link2, Loader2 } from 'lucide-react';

// Petit contrôle inline pour rattacher un bug ADO existant à un test (par son ID)
export default function LinkBugButton({ onLink, disabled = false }) {
  const [open, setOpen] = useState(false);
  const [bugId, setBugId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (disabled) return null;

  const reset = () => {
    setOpen(false);
    setBugId('');
    setError(null);
  };

  const submit = async () => {
    const id = bugId.trim().replace(/^#/, '');
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      await onLink(id);
      reset();
    } catch (err) {
      setError(err.message || 'Erreur lors de la liaison');
    } finally {
      setLoading(false);
    }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-blue-600"
        title="Lier un bug existant : entrez son numéro de work item ADO (ex: 72954, sans URL ni #)"
      >
        <Link2 className="w-3 h-3" />
        Lier
      </button>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-1">
        <input
          autoFocus
          type="text"
          value={bugId}
          onChange={e => setBugId(e.target.value)}
          onKeyDown={e => {
            if (e.key === 'Enter') submit();
            if (e.key === 'Escape') reset();
          }}
          placeholder="N° bug"
          title="Numéro du work item ADO (ex: 72954) — pas d'URL, le # est optionnel"
          disabled={loading}
          className="w-24 text-xs border border-gray-300 rounded px-1.5 py-0.5 focus:outline-none focus:border-blue-400"
        />
        <button
          onClick={submit}
          disabled={loading || !bugId.trim()}
          className="text-xs px-1.5 py-0.5 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-3 h-3 animate-spin" /> : 'OK'}
        </button>
        <button onClick={reset} disabled={loading} className="text-xs px-1.5 py-0.5 text-gray-400 hover:text-gray-600">
          Annuler
        </button>
      </div>
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
